import styled from 'styled-components';
import { unthemed } from 'tokens';

interface ProfileInitialProps {
	size: number;
	fontSize: number;
}
export const ProfileInitial = styled.div<ProfileInitialProps>`
	width: ${({ size }) => size}px;
	height: ${({ size = 32 }) => size}px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 700;
	font-size: ${({ fontSize }) => fontSize}px;
	color: ${unthemed.gray[0]};
`;
